// housekeeping/utils/utils.js
export const getPriorityColor = (priority) => {
    switch (priority) {
        case 'high': return '#dc2626';
        case 'medium': return '#d97706';
        case 'low': return '#16a34a';
        default: return '#6b7280';
    }
};
// 
export const getStatusColor = (status) => {
    switch (status) {
        case 'pending': return { bg: '#fee2e2', color: '#991b1b' };
        case 'active': return { bg: '#fef3c7', color: '#92400e' };
        case 'completed': return { bg: '#dcfce7', color: '#166534' };
        default: return { bg: '#f3f4f6', color: '#374151' };
    }
};

export const getWorkerStatusColor = (status) => {
    switch (status) {
        case 'available': return { bg: '#dcfce7', color: '#166534' };
        case 'busy': return { bg: '#fef3c7', color: '#92400e' };
        case 'off-duty': return { bg: '#f3f4f6', color: '#374151' };
        default: return { bg: '#f3f4f6', color: '#374151' };
    }
};

export const calculateTaskStatistics = (tasks) => {
    const totalTasks = tasks.length;
    const completedTasks = tasks.filter(task => task.status === 'completed').length;
    const inProgressTasks = tasks.filter(task => task.status === 'active').length;
    const highPriorityTasks = tasks.filter(task => task.priority === 'high').length;
    const completionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

    return {
        totalTasks,
        completedTasks,
        inProgressTasks,
        highPriorityTasks,
        completionRate
    };
};

export const getWorkerStats = (workerId, tasks) => {
    const workerTasks = tasks.filter(task => task.assignedTo === workerId);
    return {
        total: workerTasks.length,
        completed: workerTasks.filter(task => task.status === 'completed').length,
        active: workerTasks.filter(task => task.status === 'active').length,
        high: workerTasks.filter(task => task.priority === 'high').length
    };
};

export const getWorkerName = (workerId, workers) => {
    const worker = workers.find(w => w.id === workerId);
    return worker ? worker.name : 'Unknown';
};

export const filterTasks = (tasks, statusFilter, priorityFilter, dateFilter) => {
    return tasks.filter(task => {
        const statusMatch = statusFilter === 'All Status' || task.status === statusFilter.toLowerCase();
        const priorityMatch = priorityFilter === 'All Priority' || task.priority === priorityFilter.toLowerCase();
        const dateMatch = !dateFilter || task.dueDate.includes(dateFilter);
        return statusMatch && priorityMatch && dateMatch;
    });
};